import useNotificationsPolling from 'wb-reddit/app/routes/superGrid/actionRow/notifications/hooks/useNotificationsPolling';
import NotificationGroup from 'wb-reddit/app/routes/superGrid/actionRow/notifications/components/notificationGroup';
import Skeleton from 'wb-reddit/app/routes/superGrid/actionRow/notifications/components/skeleton';
import { useTranslation } from 'react-i18next';

const ArchivedNotifications = ({ onClose }: { onClose: () => void }) => {
	const { t } = useTranslation();
	const {
		notifications: unreadNotifications,
		groupedNotifications,
		loading,
	} = useNotificationsPolling(true);

	return (
		<div className="flex flex-col flex-1 w-full px-4 pt-[14.5px]">

			{ !loading
			&& unreadNotifications?.length === 0
			&& <div className="flex justify-center">
				{t('sc: notification.no_new_messages', "You currently don't have any new notifications!")}
			</div>
			}

			{ loading ? (
				<div className="flex flex-1 w-full items-center justify-center">
					<Skeleton />
				</div>
			) : (
				groupedNotifications.map((notificationGroup, idx) => (
					<NotificationGroup
						key={idx}
						notificationGroup={notificationGroup}
						onClose={onClose}
					/>
				))
			)}
		</div>
	);
};

export default ArchivedNotifications;
